<!-- =========================================================================================
  File Name: SessionList.vue
  Description: Session List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
@media only screen and (max-width: 1366px) {
  .header-custome h3,
  .h3 {
    font-size: 18.14px !important;
  }
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>
        Sessions
        <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows + ")" : ""
        }}</span>
      </h3>
      <!-- <h3 @click="CloneSession">
        Clone
      </h3> -->
      <div class="knowlg-base-wrap-sec">
        <span class="ml-3 text-success h3"
          >Total Sessions: {{ sessionData.length }}</span
        >
        <span class="ml-3 text-default h3"
          >Tracks: {{ sessionDataObj.Tracks }}</span
        >
        <span class="ml-3 text-primary h3"
          >Custom Url: {{ sessionDataObj.Customs }}</span
        >
        <span class="ml-3 text-primary h3"
          >In-person: {{ sessionDataObj.InPersons }}</span
        >
        <span class="ml-3 text-primary h3"
          >Live Stream: {{ sessionDataObj.LiveStreams }}</span
        >
        <span class="ml-3 text-primary h3"
          >On Demand: {{ sessionDataObj.OnDemands }}</span
        >
        <span class="ml-3 text-primary h3"
          >Roundtable: {{ sessionDataObj.RoundTables }}</span
        >
        <span class="ml-3 text-primary h3"
          >Live Panel: {{ sessionDataObj.LivePanels }}</span
        >
      </div>
    </div>
    <div class="vx-card p-6 blank-attendee" v-show="sessionData.length < 1">
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <!--<feather-icon class="" icon="RadioIcon" />-->
          <img src="../../assets/images/blank-page-images/session.png" />
        </div>
        <div class="entity-create-desc">
          <h2>Create Sessions</h2>
          <p>
            Choose from 5 different session types that suits your requirement.
            When a session is live, attendees will be able to see the video
            streams of designated speakers. Learn more about session types…
          </p>
          <div class="entity-setup-buttons">
            <vs-button color="primary" type="border" @click="getDefaultSettings"
              >ADVANCED SETTINGS</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              class="new-entity-add-button"
              @click="addRecord({ label: 'Live Panel', value: 3 })"
              >ADD NEW SESSION</vs-button
            >
            <vs-button
              color="primary"
              type="border"
              class="new-entity-add-button"
              @click="popupActive = true"
              >IMPORT SESSIONS</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card p-6" v-show="sessionData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  sessionData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : sessionData.length
                }}
                of {{ sessionData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <vs-button type="border mr-4" v-on:click="ManageTrack()"
          >Manage Track</vs-button
        >
        <!--ADD Session-->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <vs-button
            color="rgb(76, 139, 246)"
            type="filled"
            class="mr-2 flex items-center session-create-button"
            ><feather-icon icon="PlusIcon" class="mr-2" /> Create
            Session</vs-button
          >
          <vs-dropdown-menu class="py-3">
            <vs-dropdown-item
              @click="addRecord({ label: 'Custom Url', value: 5 })"
            >
              <span class="flex items-center">
                <feather-icon
                  icon="LinkIcon"
                  svgClasses="h-5 w-5 mr-2"
                  class="mr-2"
                />
                <span>Custom Url</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="addRecord({ label: 'In-person', value: 6 })"
            >
              <span class="flex items-center">
                <img
                  src="../../assets/images/icons/in-person-dark.svg"
                  style="height: 22px; width: 22px; margin-right: 10px"
                />
                <span>In-person</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="addRecord({ label: 'Live Panel', value: 3 })"
            >
              <span class="flex items-center">
                <!--<feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />-->
                <img
                  src="../../assets/images/icons/live-panel-dark.svg"
                  style="height: 22px; width: 22px; margin-right: 10px"
                />
                <span>Live Panel (Webinar)</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="addRecord({ label: 'Round Table', value: 4 })"
            >
              <span class="flex items-center">
                <!--<feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />-->
                <img
                  src="../../assets/images/icons/round-table-dark.svg"
                  style="height: 22px; width: 22px; margin-right: 10px"
                />
                <span>Round Tables</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="addRecord({ label: 'Live Stream', value: 2 })"
            >
              <span class="flex items-center">
                <!--<feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />-->
                <img
                  src="../../assets/images/icons/live-stream-dark.svg"
                  style="height: 22px; width: 22px; margin-right: 10px"
                />
                <span>Live Stream</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="addRecord({ label: 'On Demand', value: 1 })"
            >
              <span class="flex items-center">
                <!--<feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />-->
                <img
                  src="../../assets/images/icons/on-demand-dark.svg"
                  style="height: 22px; width: 22px; margin-right: 10px"
                />
                <span>On Demand</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          "
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              p-3
              shadow-drop
              rounded-lg
              d-theme-dark-light-bg
              cursor-pointer
              flex
              items-end
              justify-center
              text-lg
              font-medium
              w-32
            "
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu class="dropdown-width">
            <vs-dropdown-item @click="changeStatus(true)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Make Active</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Make Inactive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Export Session List as CSV</span>
              </span>
            </vs-dropdown-item>

            <!-- <vs-dropdown-item @click="OpenSessionExport">
              <!-- @click="popupActiveExport=true" 
              <span class="flex items-center">
                <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Download Report(s)</span>
              </span>
            </vs-dropdown-item> -->

            <vs-dropdown-item @click="OpenAutoFlowSessionExport">
              <!-- @click="popupActiveExport=true" -->
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Session Reports</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="exportvideourls()">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Export Recorded Stream URLs</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="sessionTypeConvert()">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Convert Recorded Live Panel to VOD</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="generateQR()">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Generate QR</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="deleteAllNotificationScheduling()">
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete All Expired Sessions Scheduling</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="deleteRecord()">
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete Session(s)</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-button
          color="primary"
          type="border"
          class="ml-3"
          @click="popupActive = true"
          >Import</vs-button
        >
        <vs-popup
          class="holamundo"
          title="Import Session"
          :active.sync="popupActive"
        >
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4>Download the template</h4>
              <a
                color="primary"
                type="filled"
                class="mt-3 btn"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Session.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
                >Download</a
              >
            </div>
            <!--
              <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div>
            -->
            <div class="upload-file mt-5">
              <h4>Upload your file</h4>
              <div class="file-up-section">
                <p>Select XLSX file</p>
                <input
                  type="file"
                  id="session_file"
                  accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <vs-button
                  color="rgb(76, 139, 246)"
                  type="filled"
                  class="sub-btn"
                  v-on:click="UploadSession"
                  >Upload</vs-button
                >
              </div>
            </div>
          </div>
        </vs-popup>
        <vs-button
          color="primary"
          type="border"
          class="ml-3 setting-btn"
          @click="getSettings"
        >
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button>
        <!-- Export Popup -->

        <vs-popup
          class="holamundo"
          title="Export Session"
          :active.sync="popupActiveExport"
        >
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4 id="modalsessionsSelected">Sessions Selected : 0</h4>
              <br />
              <hr />
            </div>

            <!-- <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div> -->

            <br />
            <div class="upload-file mt-5">
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="getSessionAttendanceData(1)"
                >Session Attendance</vs-button
              >&nbsp;
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="getSessionChats"
                >Session Chats</vs-button
              >&nbsp;
              <!-- <vs-button type="gradient" class="sub-btn" v-on:click="DownloadSessionQnA">Session QnA</vs-button> -->
            </div>
          </div>
        </vs-popup>

        <vs-popup
          class="holamundo"
          title="Export Session Report"
          :active.sync="popupActiveAutoFlowExport"
        >
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4 id="modalAutoflowSessionsSelected">Sessions Selected : 0</h4>
              <br />
              <hr />
            </div>
            <br />
            <div class="upload-file mt-5">
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="getSessionAttendanceData(2)"
                >Session Attendance</vs-button
              >&nbsp;
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="downloadAutoFlowChatReport"
                >Session Chats</vs-button
              >&nbsp;
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="downloadSessionQnaReport"
                >Session QnA</vs-button
              >
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn mt-3"
                v-on:click="downloadZoomAnalyticsReport"
                >Zoom Analytics</vs-button
              >
            </div>
          </div>
        </vs-popup>
        <vs-popup
          class="holamundo"
          title="Track List"
          :active.sync="popupActiveTrack"
        >
          <div class="flex flex-wrap items-center">
            <div class="flex-grow">
              <div class="vx-col w-full text-right mb-5">
                <vs-button
                  color="success"
                  type="gradient"
                  @click="openTrackPopup(null)"
                  >Add Track</vs-button
                >
              </div>
              <vs-table :data="TrackList">
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Color Code</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].Name">{{
                      data[indextr].Name
                    }}</vs-td>
                    <vs-td :data="data[indextr].ColorCode">{{
                      data[indextr].ColorCode
                    }}</vs-td>
                    <vs-td :data="data[indextr].UserId">
                      <feather-icon
                        icon="Edit3Icon"
                        title="Edit Admin"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        @click="openTrackPopup(data[indextr])"
                      />
                      <feather-icon
                        icon="TrashIcon"
                        title="Delete Admin"
                        :svgClasses="['h-6 w-6 mr-4 cursor-pointer']"
                        @click="deleteTrack(data[indextr].TrackId)"
                      ></feather-icon>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-popup>
        <vs-popup
          class="holamundo"
          :title="trackObj.TrackId ? 'Edit Track' : 'Add Track'"
          :active.sync="popupTrackSave"
        >
          <div class="add-track-inner-section">
            <vs-input
              class="inputx input-track-name w-full"
              placeholder="Track Name"
              v-model="trackObj.Name"
            />
            <!--<vs-input class="inputx input-track-name w-full" placeholder="ColorCode" v-model="ColorCode" />-->
            <div class="color-choose mt-5">
              <label>Select color code</label>
              <input class="ml-5" v-model="trackObj.ColorCode" type="color" />
            </div>
            <vs-button
              color="rgb(76, 139, 246)"
              type="filled"
              class="mt-5"
              @click="saveTrack"
              >Save</vs-button
            >
          </div>
        </vs-popup>
        <!-- Export popup ends -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="sessionData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
    <div v-if="popupActive2 == true">
      <session-settings
        :data="popupActive2"
        :key="sessionSettingsResetKey"
        v-on:saveSessionSettingsData="saveSessionSettingsData"
      />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment-timezone";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

// Store Module
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleAgendaManagement from "@/store/agenda-management/moduleAgendaManagement.js";
import moduleTrackManagement from "@/store/track-management/moduleTrackManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import SessionViewCellRendererActions from "./cell-renderer/SessionViewCellRendererActions.vue";
import parser from "ua-parser-js";
import SessionSettings from "./SessionSettings.vue";

import ls from "@/common/localStorage";
import con from "@/firebase/firebaseInit.ts";
import Swal from "sweetalert2";
//console.log(db);
//const event_collectionName = 'sayek-dev';
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var vm;
export default {
  components: {
    AgGridVue,
    vSelect,
    quillEditor,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    SessionViewCellRendererActions,
    SessionSettings,
  },
  data() {
    return {
      gridSelectedRows: 0,
      popupActiveExport: false,
      popupActiveTrack: false,
      popupTrackSave: false,
      trackObj: {
        TrackId: null,
        Name: null,
        ColorCode: null,
      },
      TrackList: [],
      zoomAnalytics: [],
      popupActiveAutoFlowExport: false,
      allAttendeeList: [],
      pageLoaded: false,
      settingsData: {
        IsMyAgendaEnabled: false,
        VideoStreamProfile: { label: "High", value: "480p_1" },
        EnableSessionRating: false,
        LiveStageLogo: null,
        LiveStageBackground: null,
        LiveStageBackgroundLandscape: null,
        AgendaFilterOption: 0,
        AllowAddRemoveMyAgenda: false,
      },
      VideoStreamProfiles: [
        { label: "High", value: "480p_1" },
        { label: "Medium", value: "360p_1" },
        { label: "Low", value: "240p_1" },
      ],
      LiveStageBackgroundPotraitsrc: null,
      LiveStageBackgroundLandscapesrc: null,
      LiveStageLogosrc: null,
      LiveStageBackgroundPotraitFile: null,
      LiveStageBackgroundLandscapeFile: null,
      LiveStageLogoFile: null,
      AgendaFilterOptions: [
        { Name: "FullAgendaOnly", Value: 0 },
        { Name: "MyAgendaOnly", Value: 1 },
        { Name: "ShowAll", Value: 2 },
      ],
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],
      IsDefaultSettings: false,
      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      sessionSettingsResetKey: 0,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      EventData: null,
      columnDefs: [
        {
          width: 50,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Session Id",
          field: "SessionId",
          hide: true,
          //width: 50,
          filter: false,
          pinned: "left",
        },
        {
          headerName: "Name",
          field: "Name",
          filter: true,
          width: 300,
          pinned: "left",
        },
        {
          headerName: "Session Type",
          field: "SessionTypeDetails.TypeName",
          filter: true,
          width: 150,
        },
        {
          headerName: "Streaming Client",
          field: "StreamingClient",
          filter: true,
          width: 180,
          cellRenderer: (data) => {
            return data.value ? data.value : "Web";
          },
        },
        {
          headerName: "Viewers",
          field: "views",
          filter: true,
          width: 150,
        },
        {
          headerName: "Speakers",
          field: "MappedSpeakers.length",
          filter: true,
          cellStyle: { "text-align": "center" },
          width: 120,
        },
        {
          headerName: "Start Date",
          field: "StartDate",
          cellRenderer: (data) => {
            //return data.value ? this.GetDateTimeFromSeconds(data.value.seconds) : '';
            return data.value
              ? this.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: true,
          width: 220,
        },
        {
          headerName: "End Date",
          field: "EndDate",
          cellRenderer: (data) => {
            //return data.value ? this.GetDateTimeFromSeconds(data.value.seconds) : '';
            return data.value
              ? this.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: true,
          width: 220,
        },
        {
          headerName: "Status",
          field: "transactions",
          width: 120,
          cellRendererFramework: "CellRendererStatus",
          cellRendererParams: (params) => {
            return {
              id: params.data.SessionId,
            };
          },
        },
        {
          headerName: "Details",
          field: "Total",
          filter: false,
          width: 100,
          cellRendererFramework: "SessionViewCellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.SessionId, name: params.data.Name };
          },
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return {
              id: params.data.SessionId,
              TypeID: params.data.SessionTypeDetails.TypeID,
            };
          },
          pinned: "right",
        },
      ],
      switch2: true,
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        SessionViewCellRendererActions,
      },
    };
  },
  watch: {
    /*roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }*/
  },
  computed: {
    sessionData() {
      return this.$store.state.sessionManagement.sessions;
    },
    sessionDataObj() {
      let sessionDataObj = {
        Customs: 0,
        InPersons: 0,
        OnDemands: 0,
        RoundTables: 0,
        LivePanels: 0,
        LiveStreams: 0,
        Tracks: 0,
      };
      this.$store.state.sessionManagement.sessions.forEach((item) => {
        sessionDataObj.Customs += item.SessionTypeDetails.TypeID == 5 ? 1 : 0;
        sessionDataObj.InPersons += item.SessionTypeDetails.TypeID == 6 ? 1 : 0;
        sessionDataObj.OnDemands += item.SessionTypeDetails.TypeID == 1 ? 1 : 0;
        sessionDataObj.LiveStreams +=
          item.SessionTypeDetails.TypeID == 2 ? 1 : 0;
        sessionDataObj.LivePanels +=
          item.SessionTypeDetails.TypeID == 3 ? 1 : 0;
        sessionDataObj.RoundTables +=
          item.SessionTypeDetails.TypeID == 4 ? 1 : 0;
        sessionDataObj.Tracks += item.Track.TrackID ? 1 : 0;
      });
      return sessionDataObj;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    CloneSession() {
      this.$store
        .dispatch("sessionManagement/cloneSession")
        .then((res) => {
          this.TrackList = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    openTrackPopup: function (dataObj) {
      if (dataObj) {
        this.trackObj = dataObj;
      } else {
        this.trackObj = {
          TrackId: null,
          Name: null,
          ColorCode: null,
        };
      }
      this.popupActiveTrack = false;
      this.popupTrackSave = true;
    },
    ManageTrack: function () {
      this.fetchTracks();
      this.popupActiveTrack = true;
    },
    fetchTracks() {
      this.$store
        .dispatch("trackManagement/fetchTracks")
        .then((res) => {
          this.TrackList = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    saveTrack: function () {
      this.$vs.loading();
      if (this.trackObj.TrackId) {
        this.$store
          .dispatch("trackManagement/updateTrack", this.trackObj)
          .then((res) => {
            this.popupTrackSave = false;
            this.$vs.loading.close();
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              text: res.message,
            });
          });
      } else {
        this.trackObj.TrackName = this.trackObj.Name;
        this.$store
          .dispatch("trackManagement/addTrackFromPopup", this.trackObj)
          .then((res) => {
            this.popupTrackSave = false;
            this.$vs.loading.close();
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              text: res.message,
            });
          });
      }
    },
    deleteTrack: function (TrackId) {
      if (confirm("Are you sure want to delete track!"))
        this.confirmDeleteTrack(TrackId);
    },
    confirmDeleteTrack: function (TrackId) {
      this.$vs.loading();
      this.$store
        .dispatch("trackManagement/deleteTrack", TrackId)
        .then((res) => {
          this.popupActiveTrack = false;
          this.$vs.loading.close();
          this.$vs.notify({
            color: res.status == 200 ? "success" : "warning",
            position: "top-center",
            text: res.message,
          });
        });
    },
    sessionTypeConvert() {
      let selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 0) {
        let sessionIds = [];
        selectedRows.map((row) => {
          if (
            row.SessionTypeDetails.TypeID == 3 &&
            row.StreamingClient != "Zoom"
          ) {
            let EndDate = row.EndDate
              ? this.SetTimeByZone(
                  new Date(row.EndDate.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : null;
            if (new Date(EndDate) < new Date()) {
              sessionIds.push(row.SessionId);
            }
          }
        });
        if (sessionIds.length) {
          this.$vs.loading();
          this.$store
            .dispatch(
              "sessionManagement/multipleSessionTypeConvert",
              sessionIds
            )
            .then((res) => {
              this.$store.dispatch("sessionManagement/fetchSessions");
              this.$vs.loading.close();
              this.$vs.notify({
                color: "success",
                position: "top-center",
                text: res.message,
              });
            })
            .catch((err) => {
              this.$vs.loading.close();
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                text: "Something went wrong!",
              });
            });
        } else {
          this.$vs.dialog({
            type: "alert",
            color: "warning",
            text: "Please select ended, livepanel, web sessions",
            acceptText: "OK",
          });
        }
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          //title: "Download Reports",
          text: "Please select atleast one session to convert. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        //this.popupActiveExport = true;
        var datarow1 = [];
        var datarow = [];

        datarow1.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        datarow1.push('"' + timezone + " Time Zone" + '"');
        datarow.push("SessionId");
        datarow.push("Name");
        datarow.push("Published");
        datarow.push("Type");
        datarow.push("Speakers");
        datarow.push("Host");
        datarow.push("Co Host");
        datarow.push("Streaming Client");
        datarow.push("Enable RTMP Stream");
        datarow.push("Start Date");
        datarow.push("End Date");
        datarow.push("Create Date");
        datarow.push("Modify Date");
        var AttendeeData = [];
        var TimeZoneHeader = [];
        TimeZoneHeader.push(datarow1);
        AttendeeData.push(datarow);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          var SessionId = row.SessionId == undefined ? "" : row.SessionId;
          datarow.push('"' + SessionId + '"');
          var Name = row.Name == undefined ? "" : row.Name.replace(/\"/g, '""');
          datarow.push('"' + Name + '"');
          datarow.push(row.IsPublished ? "Yes" : "No");
          var Type = row.SessionTypeDetails.TypeName;
          datarow.push('"' + Type + '"');
          //var Speakers = row.MappedSpeakers.length;
          var Speakers = row.MappedSpeakers.map((row) => {
            return row.Email;
          });
          datarow.push('"' + Speakers.toString() + '"');
          datarow.push(row.MappedHosts[0] ? row.MappedHosts[0].Email : "");
          datarow.push(row.MappedCoHost ? row.MappedCoHost.Email : "");
          datarow.push(row.StreamingClient == "Zoom" ? "Zoom" : "Web");
          datarow.push(row.IsZoomRTMP ? "Yes" : "No");
          let StartDate = row.StartDate
            ? this.SetTimeByZone(
                new Date(row.StartDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              )
            : null;
          datarow.push('"' + StartDate + '"');
          let EndDate = row.EndDate
            ? this.SetTimeByZone(
                new Date(row.EndDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              )
            : null;
          datarow.push('"' + EndDate + '"');
          let CreatedDate = row.CreatedDate
            ? this.SetTimeByZone(
                new Date(row.CreatedDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              )
            : null;
          datarow.push('"' + CreatedDate + '"');
          let LastModifiedDate = row.LastModifiedDate
            ? this.SetTimeByZone(
                new Date(row.LastModifiedDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              )
            : null;
          datarow.push('"' + LastModifiedDate + '"');

          AttendeeData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "SessionExport_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one session to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    exportvideourls() {
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/GetRecordedVideoUrls")
        .then((selectedRows) => {
          this.$vs.loading.close();
          if (selectedRows.length > 0) {
            var datarow = [];
            datarow.push("SessionId");
            datarow.push("Name");
            datarow.push("URL");
            var AttendeeData = [];
            AttendeeData.push(datarow);

            selectedRows.map((row) => {
              //---------------------------------------------------------
              datarow = [];
              row.urls.map((urow) => {
                datarow = [];
                var SessionId = row.sessionId == undefined ? "" : row.sessionId;
                datarow.push('"' + SessionId + '"');
                var Name =
                  row.sessionName == undefined
                    ? ""
                    : row.sessionName.replace(/\"/g, '""');
                datarow.push('"' + Name + '"');
                datarow.push(`${urow.replace(/\"/g, '""')}`);

                AttendeeData.push(datarow);
              });
              //---------------------------------------------------------
            });
            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = "SessionVideoURLSExport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Video URLS Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
        });
    },
    OpenSessionExport() {
      //alert("OpenSessionExport");
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      // console.log(selectedRows.length);
      if (selectedRows.length > 0) {
        if (selectedRows.length > 10) {
          this.$vs.dialog({
            type: "alert",
            color: "warning",
            title: "Download Reports",
            text: "Please Download report for upto 10 at a time. ",
            //accept: this.deleteRecord,
            acceptText: "OK",
          });
        } else {
          this.popupActiveExport = true;

          document.getElementById("modalsessionsSelected").innerText =
            "Session(s) Selected : " + selectedRows.length;
        }
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one session to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    getSessionAttendanceData: function (number) {
      debugger;
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      // console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");

      //-----------------------------------------------------------------------------------------------------
      if (number == 1) {
        this.downloadAttendanceFiles(selectedRows);
      } else {
        this.downloadDetailedAutoFlowReport(selectedRows);
      }

      //-----------------------------------------------------------------------------------------
      /* var batchArr = [];
      var btchCnt = 0;
      if (selectedRows.length > 10) {
        selectedRows.map((row) => {
          btchCnt++;
          if (btchCnt <= 10) {
            batchArr.push({ id: row.SessionId, Name: row.Name });
          }
          if (btchCnt == 10) {
            this.downloadAttendanceFiles(batchArr);

            btchCnt = 0;
            batchArr = [];
          }
        });
      }*/

      //---------------------------------------------------------------------------------------------
      // var btchCnt = 0;
      // selectedRows.map((row) => {
      //   btchCnt++;
      //   if (btchCnt == 10) {
      //   }
      // });

      /* selectedRows.map((row) => {
        var sessionColName =
          "OAUAT_" +
          Session_Event_Id.replace("E", "").trim() +
          "_" +
          row.SessionId;
        // console.log(sessionColName);

        var listRef = con.eventDB
          .collection(sessionColName.toString()) ///OAUAT_1591907102804_586000/Attendees/AttendeeList/191000
          .doc("Attendees")
          .collection("AttendeeList");
        debugger;
        listRef
          .get()
          .then((querySnapshot) => {
            debugger;
            //if (doc.exists) {}
            var datarow = [];
            var LocalAttendanceData = [];
            datarow.push("FullName");

            LocalAttendanceData.push(datarow);
            querySnapshot.forEach((doc) => {
              // if (doc.exists) {
              if (doc != undefined) {
                datarow = [];

                var fullname = (doc.data().FullName.toString() == undefined
                  ? ""
                  : doc.data().FullName
                )
                  .toString()
                  .trim();
                datarow.push(fullname.toString());
                LocalAttendanceData.push(datarow);
              }
              // }
            });
            // let filteredData = LocalAttendanceData.filter(
            //   (item1, ii, ar) => ar.indexOf(item1) == ii
            // );

            let csvContent = "data:text/csv;charset=utf-8,";

            LocalAttendanceData.forEach(function (rowArray) {
              let row2 = rowArray.join(",");
              csvContent += row2 + "\r\n";
            });

            var filename =
              "session_Attendance_" + row.Name + "_" + row.SessionId + ".csv";
            // console.log(filename);
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("id", "sessionAtt_" + row.SessionId);
            link.setAttribute("download", filename);
            document.body.appendChild(link);

            link.click();
          })
          .catch((error) => {
            alert(error);
          });
      });*/
    },
    downloadAttendanceFiles: function (arr) {
      var cnt = 0;
      console.log(arr);
      //   debugger;
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      arr.map((row) => {
        cnt++;
        //console.log("startPoint " + cnt);
        var sessionColName =
          "OAUAT_" +
          Session_Event_Id.replace("E", "").trim() +
          "_" +
          row.SessionId;
        // console.log(sessionColName);

        var listRef = con.eventDB
          .collection(sessionColName.toString()) ///OAUAT_1591907102804_586000/Attendees/AttendeeList/191000
          .doc("Attendees")
          .collection("AttendeeList");
        var LocalAttendanceData = [];
        listRef
          .get()
          .then((querySnapshot) => {
            //if (doc.exists) {}
            var datarow = [];
            LocalAttendanceData = [];
            datarow.push("FullName");

            LocalAttendanceData.push(datarow);
            querySnapshot.forEach((doc) => {
              //  console.log("querySnapshotPoint " + cnt);
              // if (doc.exists) {
              if (doc != undefined) {
                datarow = [];
                if (cnt > 10) {
                  //debugger;
                }
                var fullname = (
                  doc.data().FullName.toString() == undefined
                    ? ""
                    : doc.data().FullName
                )
                  .toString()
                  .trim();
                datarow.push(fullname.toString());
                LocalAttendanceData.push(datarow);
              }
              // }
            });
            // let filteredData = LocalAttendanceData.filter(
            //   (item1, ii, ar) => ar.indexOf(item1) == ii
            // );

            let csvContent = "data:text/csv;charset=utf-8,";

            LocalAttendanceData.forEach(function (rowArray) {
              // console.log("LocalAttendanceData " + cnt);
              let row2 = rowArray.join(",");
              csvContent += row2 + "\r\n";
            });

            //debugger;
            var filename =
              "session_Attendance_" + row.Name + "_" + row.SessionId + ".csv";
            // console.log(filename);
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("id", "sessionAtt_" + row.SessionId);
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            // console.log("link.click  " + cnt);
          })
          .catch((error) => {
            alert(error);
          });
      });
    },
    /* DownloadSessionQnA: function () {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");

      selectedRows.map((row) => {
        var sessionColName =
          "OAUAT_" +
          Session_Event_Id.replace("E", "").trim() +
          "_" +
          row.SessionId;
        var listRef = con.eventDB.collection(sessionColName.toString());

        console.log(sessionColName);
        listRef
          .get()
          .then((querySnapshot) => {
            // if (doc.exists) {
            var datarow = [];
            datarow.push("Date");
            datarow.push("Question");
            // datarow.push("UserID");
            datarow.push("Name");
            datarow.push("Votes");
            var LocalQnAData = [];
            LocalQnAData.push(datarow);

            querySnapshot.forEach((doc) => {
              if (doc.exists) {
                if (
                  doc.id != "Chats" &&
                  doc.id != "BroadcastSettings" &&
                  doc.id != "Attendees" &&
                  doc.id != undefined
                ) {
                  datarow = [];
                  // debugger;
                  var CreatedTime = (doc
                    .data()
                    .CreatedTime.seconds.toString() == undefined
                    ? ""
                    : this.getFormattedTime(doc.data().CreatedTime.seconds)
                  )
                    .toString()
                    .trim();
                  datarow.push(CreatedTime.toString());
                  //------------------------------------------------------------------------------
                  var Question = (doc.data().Question.toString() == undefined
                    ? ""
                    : doc.data().Question.toString().split(",").join("")
                  ).trim();
                  datarow.push(Question.toString());
                  //--------------------------------------------------------------------------------
                  var userFullName = (doc.data().UserFullName.toString() ==
                  undefined
                    ? ""
                    : doc.data().UserFullName.toString()
                  ).trim();
                  datarow.push(userFullName.toString());
                  //--------------------------------------------------------------------------------
                  var Votes = (doc.data().Votes.toString() == undefined
                    ? ""
                    : doc.data().Votes.toString()
                  ).trim();
                  datarow.push(Votes.toString());
                  //--------------------------------------------------------------------------------
                  //console.log(UserFullName.trim());
                  if (LocalQnAData.indexOf(userFullName.toString()) < 0) {
                    LocalQnAData.push(datarow);
                  }
                }
              }
            });
            // console.log("LocalQnAData:- " + LocalQnAData);
            let disQnAData = LocalQnAData.filter(
              (item1, ii, ar) => ar.indexOf(item1) == ii
            );
            //console.log("disQnAData" + disQnAData);
            let csvContent = "data:text/csv;charset=utf-8,";

            LocalQnAData.forEach(function (rowArray) {
              let row2 = rowArray.join(",");
              csvContent += row2 + "\r\n";
            });
          //    var encodedUri = encodeURI(csvContent);
          // window.open(encodedUri);
            var filename =
              "session_QnA_" + row.Name + "_" + row.SessionId + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("id", "sessionQnA_" + row.SessionId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();

            //}
          })
          .catch((error) => {
            alert(error);
            // console.log("Error getting documents: ", error);
          });
      });
    },*/
    getSessionChats: function () {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");

      selectedRows.map((row) => {
        var sessionColName =
          "OAUAT_" +
          Session_Event_Id.replace("E", "").trim() +
          "_" +
          row.SessionId;
        var listRef = con.eventDB.collection(sessionColName.toString());

        console.log(sessionColName);

        var listRef = con.eventDB
          .collection(sessionColName.toString()) //"OAUAT_1591907102804_521000_rt")
          .doc("Chats");
        listRef
          .get()
          .then(function (doc) {
            if (doc.exists) {
              var allChats = doc.data().Chats;

              var datarow = [];
              var LocalchatsData = [];
              // datarow.push("Date");
              datarow.push("Name");
              datarow.push("Message");
              // datarow.push("UserID");

              LocalchatsData.push(datarow);
              allChats.forEach((chat) => {
                datarow = [];
                debugger;
                /* if (chat.CreatedTime != undefined) {
                  var CreatedTime = (chat.CreatedTime == undefined
                    ? ""
                    : this.getFormattedTime(chat.CreatedTime.seconds)
                  )
                    .toString()
                    .trim();
                  datarow.push(CreatedTime.toString());
                }*/
                var userName = (
                  chat.UserName == undefined ? "" : chat.UserName.toString()
                ).trim();
                datarow.push(userName);
                LocalchatsData.push(datarow);
                // if (!LocalchatsData.includes(userName)) {
                //   datarow.push(userName);

                //   LocalchatsData.push(datarow);
                // }

                var Msg = (
                  chat.Msg.toString() == undefined
                    ? ""
                    : chat.Msg.toString()
                        .split("#")
                        .join("")
                        .split(",")
                        .join("")
                ).trim();
                datarow.push(Msg);
                LocalchatsData.push(datarow);
                /* var UserID = (chat.UserID.toString() == undefined
                ? ""
                : chat.UserID.toString()
              ).trim();
              datarow.push(UserID);*/
              });
              let csvContent = "data:text/csv;charset=utf-8,";
              let disQnAData = LocalchatsData.filter(
                (item1, ii, ar) => ar.indexOf(item1) == ii
              );
              disQnAData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });

              /*var encodedUri = encodeURI(csvContent);
            window.open(encodedUri);*/

              var filename =
                "Session_chat_" + row.Name + "_" + row.SessionId + ".csv";
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("id", "chat_sess_" + row.SessionId);

              link.setAttribute("download", filename);
              document.body.appendChild(link); // Required for FF

              link.click();
            }
          })
          .catch((error) => {
            alert(error);
            // console.log("Error getting documents: ", error);
          });
      });
    },

    getFormattedTime: function (seconds) {
      if (seconds == 1593171079) {
        //debugger;
      }
      var dt = new Date(seconds * 1000);
      var dte = dt.getDate();
      var mnth = dt.getMonth();
      var yr = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes;
      if (minutes != "00" && parseInt(minutes) < 10) {
        minutes = "0" + minutes;
      }
      var formattedtime =
        dte.toString() +
        "/" +
        mnth.toString() +
        "/" +
        yr.toString() +
        "  " +
        hours.toString() +
        ":" +
        minutes.toString() +
        " " +
        amPM;
      //return formattedtime;
      return formattedtime;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    fetch_event_data() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEvent", Session_Event_Id)
        .then((res) => {
          this.EventData = res.data;
        });
    },
    getDefaultSettings() {
      if (!this.settingsData.DefaultSettingsLoaded) {
        this.IsDefaultSettings = true;
        this.settingsData = {
          ActiveSpeakerFocus: false,
          ActiveSpeakerMinVolume: 0,
          ActiveSpeakerSorting: false,
          AgendaFilterOption: 2,
          AllowAddRemoveMyAgenda: true,
          AutoStartRecording: false,
          DebugMode: false,
          DisplayAudienceCounter: true,
          DisplayCompanyAndTitleInVideoTile: true,
          DisplayMaximizeButton: true,
          DisplaySessionTimer: true,
          EnableSessionRating: false,
          IsMyAgendaEnabled: false,
          LiveStageBackgroundLandscape: null,
          LiveStageBackgroundPotrait: null,
          LiveStageEndMessage:
            '<p>No more Active Sessions in Live Stage.</p><p><a href="/sessions" rel="noopener noreferrer" target="_blank">Click Here</a> to View All Sessions and On-demand videos!</p>',
          LiveStageLogo: null,
          LiveStageLogoHyperlink: "https://e2m.live/",
          PlayButtonText: null,
          ShowSessions: true,
          StartLiveStageInMaximizedMode: false,
          VideoStreamProfile: { label: "High", value: "480p_1" },
        };
      }
      this.LiveStageBackgroundPotraitsrc = null;
      this.LiveStageBackgroundLandscapesrc = null;
      this.LiveStageLogosrc = null;
      this.LiveStageBackgroundPotraitFile = null;
      this.LiveStageBackgroundLandscapeFile = null;
      this.LiveStageLogoFile = null;
      this.sessionSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    getSettings() {
      this.sessionSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    saveSettings() {
      this.$vs.loading();
      this.settingsData.AgendaFilterOption = Number(
        this.settingsData.AgendaFilterOption
      );
      this.settingsData.AllowAddRemoveMyAgenda =
        this.settingsData.AgendaFilterOption == 2
          ? this.settingsData.AllowAddRemoveMyAgenda
          : false;
      this.$store
        .dispatch("sessionManagement/saveSettings", {
          settingsData: this.settingsData,
          LiveStageBackgroundPotraitFile: this.LiveStageBackgroundPotraitFile,
          LiveStageBackgroundLandscapeFile:
            this.LiveStageBackgroundLandscapeFile,
          LiveStageLogoFile: this.LiveStageLogoFile,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$vs.loading.close();
        });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          {
            label: "All",
            value: "all",
          };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    addRecord(sessionType) {
      //this.$router.push("/event/session/add").catch(() => {});
      this.$router.push({
        name: "session-add",
        params: {
          sessionType: sessionType,
        },
      });
    },
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    UploadSession: function () {
      var files = document.getElementById("session_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "session");
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("sessionManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("sessionManagement/fetchSessions");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    generateQR() {
      let ids = this.gridApi.getSelectedRows().map((item) => item.SessionId);
      if (ids.length) {
        this.$vs.loading();
        this.$store
          .dispatch("sessionManagement/generateQR", ids)
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              text: res.message,
            });
            this.gridApi.deselectAll();
            for (let item of res.data) {
              if (item.status == 0) {
                let filename =
                  "QR_" +
                  ls.getSessionEventCollectionName() +
                  "_" +
                  item.data.substr(item.data.lastIndexOf("/"));
                this.downloadImage(item.data, filename);
              }
            }
            this.$vs.loading.close();
          })
          .catch((err) => {
            console.error(err);
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    downloadImage(url, name) {
      fetch(url)
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          a.download = name;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => console.log("An error sorry", name));
    },
    update_avatar(input, fileDimension, fieldName, srcName) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileDimension.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width == dimension[0] && this.height == dimension[1]) {
            vm[fieldName] = file;
            const reader = new FileReader();
            reader.onload = (e) => {
              vm[srcName] = e.target.result;
            };
            reader.readAsDataURL(input.target.files[0]);
          } else {
            alert("File dimension does not match " + fileDimension);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    deleteAllNotificationScheduling() {
      this.$vs.loading();
      this.$store
        .dispatch(
          "sessionManagement/deleteAllNotificationScheduling",
          this.sessionData
        )
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Notification Scheduling",
            text: "All expired sessions deleted successfully.",
          });
        });
    },
    deleteRecord() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        const { value: text } = Swal.fire({
          title: "Do you want to Delete these Session's?",
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteRecords();
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Record!",
          acceptText: "OK",
        });
      }
    },
    deleteRecords() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      let sessionIds = selectedRows.map((row) => {
        return { SessionId: row.SessionId };
      });
      this.$vs.loading();
      this.$store
        .dispatch("agendaManagement/removeSessionMappingBulk", sessionIds)
        .then((res) => {
          //alert(res.message)
          if (res.status == 200) {
            this.$store.dispatch("sessionManagement/fetchSessions");
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Delete",
              text: "Session deleted successfully.",
            });
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Delete",
              text: "Session not deleted!",
            });
          }
          this.gridApi.deselectAll();
          this.$vs.loading.close();
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    OpenAutoFlowSessionExport() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      // console.log(selectedRows.length);
      if (selectedRows.length > 0) {
        if (selectedRows.length > 10) {
          this.$vs.dialog({
            type: "alert",
            color: "warning",
            title: "Download AutoFlow Session Reports",
            text: "Please Download one report at a time. ",
            //accept: this.deleteRecord,
            acceptText: "OK",
          });
        } else {
          //this.fetchParticipantsBySessionId();
          this.allAttendeeList = [];
          this.getAttendees();
          this.popupActiveAutoFlowExport = true;
          document.getElementById("modalAutoflowSessionsSelected").innerText =
            "Session(s) Selected : " + selectedRows.length;
        }
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download AutoFlow Session Reports",
          text: "Please select atleast one session to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    downloadAutoFlowChatReport: function () {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$vs.loading();
      console.log(cn);

      selectedRows.map((row) => {
        con.eventDB
          .collection(cn)
          .doc("UserVideoActivity")
          .collection("Session")
          .doc(row.SessionId)
          .collection("Chat")
          .get()
          .then((querySnapshot) => {
            var datarow = [];
            var timeZone = [];

            timeZone.push("Report Exported In ");
            var timezone =
              Session_Event_TZ == undefined ? "" : Session_Event_TZ;
            timeZone.push('"' + timezone + " Time Zone" + '"');

            datarow.push("Chat Id");
            datarow.push("Name");
            datarow.push("Message");
            datarow.push("Sent Time");
            var Localparticipance = [];
            Localparticipance.push(datarow);
            var TimeZoneHeader = [];
            TimeZoneHeader.push(timeZone);

            querySnapshot.forEach((doc) => {
              datarow = [];
              var chatId =
                doc.data().ChatId == undefined ? "" : doc.data().ChatId;
              datarow.push(chatId);
              var userName = (
                doc.data().Name == undefined ? "" : doc.data().Name.toString()
              ).trim();
              datarow.push(userName);
              var Msg = (
                doc.data().Message.toString() == undefined
                  ? ""
                  : doc
                      .data()
                      .Message.toString()
                      .split("#")
                      .join("")
                      .split(",")
                      .join("")
              ).trim();
              datarow.push(Msg);
              var sentTime =
                doc.data().CreatedDate == undefined ||
                doc.data().CreatedDate == null
                  ? "NA"
                  : '"' +
                    this.SetTimeByZone(
                      new Date(
                        doc.data().CreatedDate.seconds * 1000
                      ).toUTCString(),
                      Session_Event_TZ
                    ) +
                    '"';
              datarow.push(sentTime);
              Localparticipance.push(datarow);
            });
            let csvContent = "data:text/csv;charset=utf-8,";

            TimeZoneHeader.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            Localparticipance.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });

            var filename =
              "AutoFlow_Chat_" + "_" + row.SessionId + "_" + row.Name + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("id", "AutoFlow_Chat" + row.SessionId);
            link.setAttribute("download", filename);
            this.$vs.loading.close();
            document.body.appendChild(link); // Required for FF

            link.click();
          });
      });
    },
    getFormattedDateForExport: function (seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.toLocaleString("default", { month: "short" });
      var year = dt.getFullYear();

      var formattedValue = month + ", " + day.toString() + ", " + year;
      return formattedValue;
    },
    getFormattedTimeForExport: function (seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
      var formattedValue = hours.toString() + ":" + minutes.toString() + ":";
      return formattedValue;
    },
    downloadDetailedAutoFlowReport(arr) {
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$vs.loading();
      arr.map((row) => {
        //making the column names
        var datarow = [];
        var datarow1 = [];
        var datarow2 = [];
        var datarow3 = [];
        var datarow4 = [];
        var datarow5 = [];
        var timeZone = [];

        datarow.push("Attendee Report");

        timeZone.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"' + timezone + " Time Zone" + '"');

        datarow1.push("Session ID");
        datarow1.push("Session Name");
        datarow1.push("Session Type");
        datarow1.push("Session Start Time");
        datarow1.push("Session End Time");
        datarow1.push("Session Duration (minutes)");
        datarow1.push("Total Attendees in Event");
        datarow1.push("Attended this Session");

        datarow2.push("Host/Speakers Attendance");

        datarow3.push("Attended");
        datarow3.push("User Name");
        datarow3.push("Email");
        datarow3.push("Company");
        datarow3.push("Join Time");
        datarow3.push("Leave Time");
        datarow3.push("Device Info");
        datarow3.push("Country/Region Name");

        datarow4.push("Audience attendance");

        datarow5.push("Attended");
        datarow5.push("Name");
        //datarow5.push("Last Name");
        datarow5.push("Email");
        datarow5.push("Registration Type");
        datarow5.push("Company");
        datarow5.push("Join Time");
        datarow5.push("Leave Time");
        datarow5.push("Device Info");
        datarow5.push("Country/Region Name");

        var AttendeeData = [];
        AttendeeData.push(datarow);

        var TimeZoneHeader = [];
        TimeZoneHeader.push(timeZone);

        var SessionData = [];
        SessionData.push(datarow1);

        var HostOrSpeakerData = [];
        HostOrSpeakerData.push(datarow2);

        var HostOrSpeakerDetailsData = [];
        HostOrSpeakerDetailsData.push(datarow3);

        var AudianceAttendance = [];
        AudianceAttendance.push(datarow4);

        var AudianceAttendanceDetails = [];
        AudianceAttendanceDetails.push(datarow5);
        //---------------------------------------------------------
        datarow = [];
        datarow1 = [];

        var text = "Report Generated:";
        datarow.push(text);
        //pushing data for the session section
        var sessionId = row.SessionId == undefined ? "" : row.SessionId;
        datarow1.push(sessionId);
        var sessionName = row.Name == undefined ? "" : row.Name;
        datarow1.push(sessionName);
        var sessionType =
          row.SessionTypeDetails.TypeName == undefined
            ? ""
            : row.SessionTypeDetails.TypeName;
        datarow1.push(sessionType);
        var sessionStartTime =
          row.StartDate == undefined
            ? ""
            : '"' +
              this.SetTimeByZone(
                new Date(row.StartDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              ) +
              '"';
        datarow1.push(sessionStartTime);
        var sessionEndTime =
          row.EndDate == undefined
            ? ""
            : '"' +
              this.SetTimeByZone(
                new Date(row.EndDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              ) +
              '"';
        datarow1.push(sessionEndTime);

        var sessionDuration =
          row.StartDate == undefined && row.EndDate == undefined
            ? ""
            : this.getSessionDuration(
                row.StartDate.seconds,
                row.EndDate.seconds
              );
        datarow1.push(sessionDuration);

        var currentDate = new Date();
        var formatedDate =
          currentDate.toLocaleString("default", {
            month: "short",
          }) +
          " " +
          currentDate.getDate() +
          "," +
          currentDate.getFullYear() +
          " " +
          currentDate.getHours() +
          ":" +
          currentDate.getMinutes();
        datarow.push('"' + formatedDate + '"');

        var joinedSessionCounter = 0;
        var listCompletedFlg = false;
        var participantsList = [];
        var hostJoinedAttendeeIds = [];
        var speakerJoinedAttendeeIds = [];
        var attendeesWhoJoinedIds = [];
        //fetching the participants list
        con.eventDB
          .collection(cn)
          .doc("SessionList")
          .collection("Sessions")
          .doc(row.SessionId)
          .collection("Participances")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.forEach((doc) => {
                participantsList.push(doc.data());
              });
              if (participantsList.length > 0) {
                participantsList.map((row1) => {
                  //if attndee type host or speaker
                  if (row1.AttendeeType == 1 || row1.AttendeeType == 2) {
                    row.MappedHosts.map((row3) => {
                      if (row3.AttendeeId == row1.AttendeeId) {
                        if (row1.JoinTime != null) {
                          joinedSessionCounter += 1;
                        }
                        datarow3 = [];
                        hostJoinedAttendeeIds.push(row3.AttendeeId);
                        var attended =
                          row1.JoinTime == undefined ? "No " : "Yes ";
                        datarow3.push(attended);
                        var name = row1.Name == undefined ? "" : row1.Name;
                        datarow3.push('"' + name + '"');

                        var email = row3.Email == undefined ? "NA" : row3.Email;
                        datarow3.push('"' + email + '"');

                        var company =
                          row1.Company == undefined ? "" : row1.Company;
                        datarow3.push('"' + company + '"');

                        var joinTime =
                          row1.JoinTime == undefined || row1.JoinTime == null
                            ? "NA"
                            : '"' +
                              '"' +
                              this.SetTimeByZone(
                                new Date(
                                  row1.JoinTime.seconds * 1000
                                ).toUTCString(),
                                Session_Event_TZ
                              ) +
                              '"';
                        datarow3.push(joinTime);
                        if (
                          row1.LeaveTime == undefined ||
                          row1.LeaveTime == null
                        ) {
                          datarow3.push("NA");
                        } else if (
                          row1.LeaveTime.seconds <= row1.JoinTime.seconds
                        ) {
                          datarow3.push("NA");
                        } else {
                          var leaveTime =
                            row1.LeaveTime == undefined ||
                            row1.LeaveTime == null
                              ? "NA"
                              : '"' +
                                this.SetTimeByZone(
                                  new Date(
                                    row1.LeaveTime.seconds * 1000
                                  ).toUTCString(),
                                  Session_Event_TZ
                                ) +
                                '"';
                          datarow3.push(leaveTime);
                        }

                        var deviceInfo =
                          row1.UserAgent == undefined || row1.UserAgent == null
                            ? "NA"
                            : '"' + this.getDevice(row1.UserAgent) + '"';
                        datarow3.push(deviceInfo);

                        var country =
                          row1.Country == undefined ? "" : row1.Country;
                        datarow3.push(country);
                      } else {
                        var notloggedinMappedParticipants = [];
                        row.MappedHosts.map((doc, index) => {
                          if (
                            hostJoinedAttendeeIds.includes(doc.AttendeeId) ==
                            false
                          ) {
                            notloggedinMappedParticipants.push(doc);
                          }
                        });
                      }
                    });
                    row.MappedSpeakers.map((row2) => {
                      if (row2.AttendeeId == row1.AttendeeId) {
                        if (row1.JoinTime != null) {
                          joinedSessionCounter += 1;
                        }
                        datarow3 = [];
                        speakerJoinedAttendeeIds.push(row2.AttendeeId);
                        var attended =
                          row1.JoinTime == undefined ? "No " : "Yes ";
                        datarow3.push(attended);
                        var name = row1.Name == undefined ? "" : row1.Name;
                        datarow3.push('"' + name + '"');

                        var email = row2.Email == undefined ? "NA" : row2.Email;
                        datarow3.push('"' + email + '"');

                        var company =
                          row1.Company == undefined ? "" : row1.Company;
                        datarow3.push('"' + company + '"');

                        var joinTime =
                          row1.JoinTime == undefined || row1.JoinTime == null
                            ? "NA"
                            : '"' +
                              this.SetTimeByZone(
                                new Date(
                                  row1.JoinTime.seconds * 1000
                                ).toUTCString(),
                                Session_Event_TZ
                              ) +
                              '"';
                        datarow3.push(joinTime);
                        if (
                          row1.LeaveTime == undefined ||
                          row1.LeaveTime == null
                        ) {
                          datarow3.push("NA");
                        } else if (
                          row1.LeaveTime.seconds <= row1.JoinTime.seconds
                        ) {
                          datarow3.push("NA");
                        } else {
                          var leaveTime =
                            row1.LeaveTime == undefined ||
                            row1.LeaveTime == null
                              ? "NA"
                              : '"' +
                                this.SetTimeByZone(
                                  new Date(
                                    row1.LeaveTime.seconds * 1000
                                  ).toUTCString(),
                                  Session_Event_TZ
                                ) +
                                '"';
                          datarow3.push(leaveTime);
                        }
                        var deviceInfo =
                          row1.UserAgent == undefined || row1.UserAgent == null
                            ? "NA"
                            : '"' + this.getDevice(row1.UserAgent) + '"';
                        datarow3.push(deviceInfo);

                        var country =
                          row1.Country == undefined ? "" : row1.Country;
                        datarow3.push(country);
                      } else {
                        var notloggedinMappedParticipants = [];
                        row.MappedSpeakers.map((doc, index) => {
                          if (
                            speakerJoinedAttendeeIds.includes(doc.AttendeeId) ==
                            false
                          ) {
                            notloggedinMappedParticipants.push(doc);
                          }
                        });
                      }
                    });
                    // pushing the records of host/speaker who joined
                    HostOrSpeakerDetailsData.push(datarow3);
                  } else {
                    // participants who joined but are not host or speaker
                    attendeesWhoJoinedIds.push(row1.AttendeeId);
                    datarow5 = [];
                    var attended = row1.JoinTime == undefined ? "No " : "Yes ";
                    if (row1.JoinTime != null) {
                      joinedSessionCounter += 1;
                    }
                    datarow5.push(attended);
                    var name = row1.Name == undefined ? "" : row1.Name;
                    datarow5.push('"' + name + '"');
                    // var lname = row1.LastName == undefined ? "" : row1.LastName;
                    // datarow5.push('"' + lname + '"');
                    var email = null;
                    var registrationType = null;
                    this.allAttendeeList.map((row4) => {
                      if (row4.AttendeeId == row1.AttendeeId) {
                        email =
                          row4.Email == undefined ||
                          row4.Email == "" ||
                          row4.Email == null
                            ? "NA"
                            : row4.Email;
                        registrationType = row4.RegistrationType
                          ? row4.RegistrationType.RegistrationType
                          : "NA";
                        for (let field of row4.DefaultFields) {
                          if (
                            field.Name &&
                            field.Name == "Attendeetype" &&
                            field.value
                          )
                            registrationType = field.value.toString();
                        }
                        //datarow5.push('"' + email + '"');
                      }
                    });
                    datarow5.push('"' + email + '"');
                    datarow5.push('"' + registrationType + '"');
                    var company = row1.Company == undefined ? "" : row1.Company;
                    datarow5.push('"' + company + '"');
                    var joinTimeNotHost =
                      row1.JoinTime == undefined || row1.JoinTime == null
                        ? "NA"
                        : '"' +
                          this.SetTimeByZone(
                            new Date(
                              row1.JoinTime.seconds * 1000
                            ).toUTCString(),
                            Session_Event_TZ
                          ) +
                          '"';
                    datarow5.push(joinTimeNotHost);
                    if (row1.LeaveTime == undefined || row1.LeaveTime == null) {
                      datarow5.push("NA");
                    } else if (row1.LeaveTime <= row1.JoinTime) {
                      datarow5.push("NA");
                    } else {
                      var leaveTimeNotHost =
                        row1.LeaveTime == undefined || row1.LeaveTime == null
                          ? "NA"
                          : '"' +
                            this.SetTimeByZone(
                              new Date(
                                row1.LeaveTime.seconds * 1000
                              ).toUTCString(),
                              Session_Event_TZ
                            ) +
                            '"';
                      datarow5.push(leaveTimeNotHost);
                    }
                    var deviceInfo =
                      row1.UserAgent == undefined || row1.UserAgent == null
                        ? "NA"
                        : '"' + this.getDevice(row1.UserAgent) + '"';
                    datarow5.push(deviceInfo);
                    var countryIndividualHost =
                      row1.Country == undefined ? "" : row1.Country;
                    datarow5.push(countryIndividualHost);
                    AudianceAttendanceDetails.push(datarow5);
                  }
                });
                //attendee who didnt join the session
                var notloggedinAttendees = [];
                this.allAttendeeList.map((doc) => {
                  if (
                    hostJoinedAttendeeIds.includes(doc.AttendeeId) == false &&
                    speakerJoinedAttendeeIds.includes(doc.AttendeeId) ==
                      false &&
                    attendeesWhoJoinedIds.includes(doc.AttendeeId) == false
                  ) {
                    notloggedinAttendees = [];
                    var attended = "No ";
                    notloggedinAttendees.push(attended);
                    var name = doc.Name == undefined ? "" : doc.Name;
                    notloggedinAttendees.push('"' + name + '"');
                    // var lname = doc.LastName == undefined ? "" : doc.LastName;
                    // notloggedinAttendees.push('"' + lname + '"');
                    var email = doc.Email == undefined ? "NA" : doc.Email;
                    var registrationType = doc.RegistrationType
                      ? doc.RegistrationType.RegistrationType
                      : "NA";
                    for (let field of doc.DefaultFields) {
                      if (
                        field.Name &&
                        field.Name == "Attendeetype" &&
                        field.value
                      )
                        registrationType = field.value.toString();
                    }
                    notloggedinAttendees.push('"' + email + '"');
                    notloggedinAttendees.push('"' + registrationType + '"');
                    var company = doc.Company == undefined ? "" : doc.Company;
                    notloggedinAttendees.push('"' + company + '"');
                    notloggedinAttendees.push("NA");
                    notloggedinAttendees.push("NA");
                    notloggedinAttendees.push("NA");
                    var countryIndividualHost =
                      doc.Country == undefined ? "" : doc.Country;
                    notloggedinAttendees.push(countryIndividualHost);

                    AudianceAttendanceDetails.push(notloggedinAttendees);
                  }
                });
              }

              listCompletedFlg = true;
              if (listCompletedFlg) {
                //creating the csv file
                AttendeeData.push(datarow);
                datarow1.push(this.allAttendeeList.length);
                datarow1.push(participantsList.length);
                SessionData.push(datarow1);

                let csvContent = "data:text/csv;charset=utf-8,";
                var dt = new Date().toISOString().slice(0, 10);
                AttendeeData.forEach(function (rowArray) {
                  let row = rowArray.join(",");
                  csvContent += row + "\r\n";
                });
                TimeZoneHeader.forEach(function (rowArray) {
                  let row = rowArray.join(",");
                  csvContent += row + "\r\n";
                });
                SessionData.forEach(function (rowArray) {
                  let row = rowArray.join(",");
                  csvContent += row + "\r\n";
                });
                HostOrSpeakerData.forEach(function (rowArray) {
                  let row = rowArray.join(",");
                  csvContent += row + "\r\n";
                });
                HostOrSpeakerDetailsData.forEach(function (rowArray) {
                  let row = rowArray.join(",");
                  csvContent += row + "\r\n";
                });
                AudianceAttendance.forEach(function (rowArray) {
                  let row = rowArray.join(",");
                  csvContent += row + "\r\n";
                });
                AudianceAttendanceDetails.forEach(function (rowArray) {
                  let row = rowArray.join(",");
                  csvContent += row + "\r\n";
                });
                
                var filename =
                  "AutoFlowSessionReport_" + row.SessionId + "_" + dt + ".csv";
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", filename);
                this.$vs.loading.close();
                document.body.appendChild(link); // Required for FF
                AttendeeData = [];
                SessionData = [];
                HostOrSpeakerData = [];
                HostOrSpeakerDetailsData = [];
                AudianceAttendance = [];
                AudianceAttendanceDetails = [];

                link.click();
              }
            } else {
              /// when participants collection is blank
              this.allAttendeeList.map((row4) => {
                datarow5 = [];
                // participants who didnt participate
                var attended = "No";
                datarow5.push(attended);
                var name = row4.Name == undefined ? "" : row4.Name;
                datarow5.push(name);
                // var lname = row4.LastName == undefined ? "" : row4.LastName;
                // datarow5.push(lname);
                var email = row4.Email == undefined ? "" : row4.Email;
                datarow5.push(email);
                var company = row4.Company == undefined ? "" : row4.Company;
                datarow5.push(company);

                datarow5.push("NA");
                datarow5.push("NA");
                datarow5.push("NA");
                var countryIndividualHost =
                  row4.Country == undefined ? "" : row4.Country;
                datarow5.push(countryIndividualHost);

                AudianceAttendanceDetails.push(datarow5);
              });
              AttendeeData.push(datarow);
              datarow1.push(this.allAttendeeList.length);
              datarow1.push(joinedSessionCounter);
              SessionData.push(datarow1);
              let csvContent = "data:text/csv;charset=utf-8,";
              var dt = new Date().toISOString().slice(0, 10);
              AttendeeData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              TimeZoneHeader.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              SessionData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              HostOrSpeakerData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              HostOrSpeakerDetailsData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              AudianceAttendance.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              AudianceAttendanceDetails.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              var filename =
                "AutoFlowSessionReport_" + row.SessionId + "_" + dt + ".csv";
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("download", filename);
              this.$vs.loading.close();
              document.body.appendChild(link); // Required for FF
              AttendeeData = [];
              SessionData = [];
              HostOrSpeakerData = [];
              HostOrSpeakerDetailsData = [];
              AudianceAttendance = [];
              AudianceAttendanceDetails = [];

              link.click();
            }
          });
      });
    },
    getSessionDuration(startDateInSec, endDateInSec) {
      var diff = endDateInSec - startDateInSec;
      var minutes = Math.floor(diff / 60);
      return minutes;
    },
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].IsPublished) {
            this.allAttendeeList.push({
              AttendeeId: res[i].AttendeeId,
              Company: res[i].Company,
              Designation: res[i].Designation,
              Email: res[i].Email,
              FirstName: res[i].FirstName,
              LastName: res[i].LastName,
              Name: res[i].Name,
              Phone: res[i].Phone,
              ProfilePictureURL: res[i].ProfilePictureURL,
              RegistrationType: res[i].RegistrationType
                ? res[i].RegistrationType
                : null,
              DefaultFields:
                res[i].DefaultFields && res[i].DefaultFields.length
                  ? res[i].DefaultFields
                  : [],
            });
          }
        }
      });
    },
    getDevice: function (uastring) {
      //debugger;
      var retVal = "";
      var result = parser(uastring);

      //console.log(parser);
      //console.log(result);
      //parser.setUA(uastring);
      //var result = parser.getResult();
      // this will also produce the same result (without instantiation):
      // var result = UAParser(uastring);
      if (result.device != undefined) {
        if (result.device.vendor != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.device.vendor;
          if (result.device.model != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.device.model;
          }
        }
      }
      if (result.os != undefined) {
        if (result.os.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.os.name;
          if (result.os.version != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.os.version;
          }
        }
      }
      if (result.browser != undefined) {
        if (result.browser.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.browser.name;
          if (result.browser.major != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.browser.major;
          }
        }
      }
      return retVal;
    },
    downloadSessionQnaReport() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      // console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      //	this.$vs.loading();
      selectedRows.map((row) => {
        //making the column names
        var datarow = [];
        var datarow1 = [];
        var datarow2 = [];
        var datarow3 = [];
        var timeZone = [];

        datarow.push("Session QnA Report");

        timeZone.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"' + timezone + " Time Zone" + '"');

        datarow1.push("Session ID");
        datarow1.push("Session Name");
        datarow1.push("Session Type");
        datarow1.push("Session Start Time");
        datarow1.push("Session End Time");
        datarow1.push("Session Duration (minutes)");

        datarow2.push("Questions");

        datarow3.push("ID");
        datarow3.push("Question");
        datarow3.push("Published");
        datarow3.push("Asked By");
        datarow3.push("Asked On");
        datarow3.push("Total Likes");
        datarow3.push("Total Dislikes");

        var AttendeeData = [];
        AttendeeData.push(datarow);

        var TimeZoneHeader = [];
        TimeZoneHeader.push(timeZone);

        var SessionData = [];
        SessionData.push(datarow1);

        var HostOrSpeakerData = [];
        HostOrSpeakerData.push(datarow2);

        var HostOrSpeakerDetailsData = [];
        HostOrSpeakerDetailsData.push(datarow3);

        //---------------------------------------------------------
        datarow = [];
        datarow1 = [];

        var text = "Report Generated:";
        datarow.push(text);
        //pushing data for the session section
        var sessionId = row.SessionId == undefined ? "" : row.SessionId;
        datarow1.push(sessionId);
        var sessionName = row.Name == undefined ? "" : row.Name;
        datarow1.push(sessionName);
        var sessionType =
          row.SessionTypeDetails.TypeName == undefined
            ? ""
            : row.SessionTypeDetails.TypeName;
        datarow1.push(sessionType);
        var sessionStartTime =
          row.StartDate == undefined
            ? ""
            : '"' +
              this.SetTimeByZone(
                new Date(row.StartDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              ) +
              '"';
        datarow1.push(sessionStartTime);
        var sessionEndTime =
          row.EndDate == undefined
            ? ""
            : '"' +
              this.SetTimeByZone(
                new Date(row.EndDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              ) +
              '"';
        datarow1.push(sessionEndTime);

        var sessionDuration =
          row.StartDate == undefined && row.EndDate == undefined
            ? ""
            : this.getSessionDuration(
                row.StartDate.seconds,
                row.EndDate.seconds
              );
        datarow1.push(sessionDuration);

        var currentDate = new Date();
        var formatedDate =
          currentDate.toLocaleString("default", {
            month: "short",
          }) +
          " " +
          currentDate.getDate() +
          "," +
          currentDate.getFullYear() +
          " " +
          currentDate.getHours() +
          ":" +
          currentDate.getMinutes();
        datarow.push('"' + formatedDate + '"');
        var listCompletedFlg = false;

        datarow3 = [];
        con.eventDB
          .collection(cn)
          .doc("UserVideoActivity")
          .collection("Session")
          .doc(row.SessionId)
          .collection("QnA")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              //console.log("data=======>>>",doc.data());
              var id = doc.data().QnAId == undefined ? " " : doc.data().QnAId;
              datarow3.push('"' + id + '"');
              var question =
                doc.data().Question == undefined ? " " : doc.data().Question;
              datarow3.push('"' + question + '"');
              var published = doc.data().IsPublished == true ? "Yes" : "No";
              datarow3.push('"' + published + '"');
              var askedBy;
              if (!doc.data().IsAnonymous) {
                askedBy = doc.data().Name == undefined ? " " : doc.data().Name;
              } else {
                askedBy = "Anonymous";
              }
              datarow3.push('"' + askedBy + '"');
              var akedOn =
                doc.data().CreatedDate == undefined
                  ? "NA"
                  : this.SetTimeByZone(
                      new Date(
                        doc.data().CreatedDate.seconds * 1000
                      ).toUTCString(),
                      Session_Event_TZ
                    );
              datarow3.push('"' + akedOn + '"');
              var totalLikes = doc.data().TotalLikes;
              datarow3.push('"' + totalLikes + '"');
              var totalDisLikes = doc.data().TotalDislikes;
              datarow3.push('"' + totalDisLikes + '"');
              HostOrSpeakerDetailsData.push(datarow3);
              datarow3 = [];
            });
            listCompletedFlg = true;
            if (listCompletedFlg) {
              AttendeeData.push(datarow);
              SessionData.push(datarow1);

              let csvContent = "data:text/csv;charset=utf-8,";
              var dt = new Date().toISOString().slice(0, 10);
              AttendeeData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              TimeZoneHeader.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              SessionData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              HostOrSpeakerData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              HostOrSpeakerDetailsData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              var filename =
                "AutoFlowSessionQnAReport_" + row.SessionId + "_" + dt + ".csv";
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("download", filename);
              //this.$vs.loading.close();
              document.body.appendChild(link); // Required for FF
              AttendeeData = [];
              SessionData = [];
              HostOrSpeakerData = [];
              HostOrSpeakerDetailsData = [];
              link.click();
            }
          });
      });
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    downloadZoomAnalyticsReport() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //this.$vs.loading();
      selectedRows.map((row) => {
        console.log("row=====", row);
        if (row.StreamingClient == "Zoom") {
          if (row.Zoom_Detail != undefined) {
            if (row.IsZoomRTMP == true) {
              if (row.Zoom_Detail.id != undefined) {
                this.$store
                  .dispatch(
                    "sessionManagement/fetchZoomMeetingAnalytics",
                    row.Zoom_Detail.id
                  )
                  .then((res) => {
                    this.zoomAnalytics = res;
                    //this.$vs.loading.close();
                    if (this.zoomAnalytics.length > 0) {
                      this.makeZoomAnalyticsCsv(row);
                    } else {
                      // this.$vs.loading.close();
                      alert(
                        "Please download the report after the Webinar/Meeting has ended."
                      );
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                    // this.$vs.loading.close();
                  });
              } else {
                // this.$vs.loading.close();
                alert("Error in Zoom setup, please contact Support.");
                //this.$vs.loading.close();
              }
            } else {
              if (row.Zoom_Detail.id != undefined) {
                this.$store
                  .dispatch(
                    "sessionManagement/fetchZoomWebinarAnalytics",
                    row.Zoom_Detail.id
                  )
                  .then((res) => {
                    this.zoomAnalytics = res;
                    // this.$vs.loading.close();
                    if (this.zoomAnalytics.length > 0) {
                      this.makeZoomAnalyticsCsv(row);
                    } else {
                      // this.$vs.loading.close();
                      alert(
                        "Please download the report after the Webinar/Meeting has ended."
                      );
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                    //  this.$vs.loading.close();
                  });
              } else {
                //this.$vs.loading.close();
                alert("Error in Zoom setup, please contact Support.");
                // this.$vs.loading.close();
              }
            }
          } else {
            //this.$vs.loading.close();
            alert(
              "An unknown error occurred with Zoom, please try again in a while or contact Support"
            );
          }
        } else {
          // this.$vs.loading.close();
          alert("Report is not yet ready, please try after sometime");
        }
      });
    },
    makeZoomAnalyticsCsv(data) {
      this.$vs.loading();
      var datarow = [];
      var timeZone = [];
      var sessions = [];

      timeZone.push("Report Exported In ");
      var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
      timeZone.push('"' + timezone + " Time Zone" + '"');

      sessions.push("Session Name");
      var sessionName = data.Name;
      sessions.push('"' + sessionName + '"');

      datarow.push("Name");
      datarow.push("Email");
      datarow.push("Type");
      datarow.push("Join Time");
      datarow.push("Leave Time");
      datarow.push("Duration in Mins");
      var userLoginData = [];
      userLoginData.push(datarow);

      var TimeZoneHeader = [];
      TimeZoneHeader.push(timeZone);

      var SessionHeader = [];
      SessionHeader.push(sessions);

      this.zoomAnalytics.map((row1) => {
        datarow = [];
        var name = row1.name == undefined ? "" : row1.name;
        datarow.push('"' + name + '"');
        var email = row1.user_email == undefined ? "" : row1.user_email;
        datarow.push('"' + email + '"');

        var type =
          row1.user_email == undefined
            ? ""
            : this.checkUserType(row1.user_email, data);
        datarow.push('"' + type + '"');

        var joinDate =
          row1.join_time == undefined
            ? ""
            : '"' +
              row1.join_time.slice(0, 10) +
              " " +
              row1.join_time.slice(11, 19) +
              '"';
        datarow.push(joinDate);
        var leaveDate =
          row1.leave_time == undefined
            ? ""
            : '"' +
              row1.leave_time.slice(0, 10) +
              " " +
              row1.leave_time.slice(11, 19) +
              '"';
        datarow.push(leaveDate);
        var duration =
          row1.duration == undefined
            ? ""
            : '"' + Math.floor(row1.duration / 60) + '"';
        datarow.push(duration);

        userLoginData.push(datarow);
      });
      let csvContent = "data:text/csv;charset=utf-8,";
      var dt = new Date().toISOString().slice(0, 10);
      // TimeZoneHeader.forEach(function (rowArray) {
      //   let row = rowArray.join(",");
      //   csvContent += row + "\r\n";
      // });
      SessionHeader.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      userLoginData.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var filename = "ZoomData" + "_" + sessionName + "_" + dt + ".csv";
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      //link.setAttribute("id", "Participance_RT_" + row.TableId);
      link.setAttribute("download", filename);
      document.body.appendChild(link); // Required for FF
      link.click();
      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
    checkUserType(email, data) {
      var hostEmails = [];
      var speakerEmails = [];

      data.MappedHosts.map((row) => {
        hostEmails.push(row.Email.trim());
      });
      data.MappedSpeakers.map((row) => {
        speakerEmails.push(row.Email.trim());
      });
      if (
        data.MappedCoHost != undefined &&
        data.MappedCoHost.Email == email.trim()
      ) {
        return "Co-Host";
      } else if (hostEmails.includes(email.trim())) {
        return "Host";
      } else if (speakerEmails.includes(email.trim())) {
        return "Speaker";
      } else {
        return "Attendee";
      }
    },
    showResponsivePreview() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
      let CustomDomain = ls.getSessionValueByKey("CustomDomain");
      window.open(
        `https://${CustomDomain}/joincms/${Session_Client_Id}/${Session_Event_Id}/preview`,
        "_blank"
      );
    },
    saveSessionSettingsData() {
      this.settingsData = {
        DefaultSettingsLoaded: true,
      };
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    vm = this;
    /*if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })*/
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    this.$vs.loading();
    this.$store.dispatch("sessionManagement/getSettings").then((res) => {
      this.settingsData = res;
      this.$store.dispatch("sessionManagement/fetchSessions").then((res) => {
        this.pageLoaded = true;
        this.$vs.loading.close();
      });
    });

    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleAgendaManagement.isRegistered) {
      this.$store.registerModule("agendaManagement", moduleAgendaManagement);
      moduleAgendaManagement.isRegistered = true;
    }
    if (!moduleTrackManagement.isRegistered) {
      this.$store.registerModule("trackManagement", moduleTrackManagement);
      moduleTrackManagement.isRegistered = true;
    }
    this.fetch_event_data();
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>